export default __webpack_public_path__ + "static/media/down-arrow-white.icon.c8f3e727.svg";